import moment from 'moment';

const formatToTwoSignificance = (num: Number) => {
  return num < 10 ? `0${num}` : num;
};

export default function dateFormatter(dateStr: string | number) {
  const datetime = new Date(dateStr); // Converts to local time so need to make sure to use the 'UTC' methods
  const date = `${datetime.getUTCFullYear()}-${formatToTwoSignificance(
    datetime.getUTCMonth() + 1,
  )}-${formatToTwoSignificance(datetime.getUTCDate())}`;
  const time = `${formatToTwoSignificance(
    datetime.getUTCHours(),
  )}:${formatToTwoSignificance(
    datetime.getUTCMinutes(),
  )}:${formatToTwoSignificance(datetime.getUTCSeconds())}`;
  return { date, time };
}

export function xDaysAgo(noDaysAgo: number) {
  return moment().subtract(noDaysAgo, 'days').utc().startOf('day');
}

export function endOfToday() {
  return moment().utc().endOf('day');
}
